const getDisplayIndexWithPadding = (displayIndex: number) => {
    const isTwoDigit = displayIndex > 9;

    const padding = isTwoDigit ? "" : "0";

    return `${padding}${displayIndex}`;
};

export default getDisplayIndexWithPadding;
